import { Checkbox } from '@mantine/core';

interface Props {
  onChange?: () => void;
  checked?: boolean;
  color?: string;
  disabled?: boolean;
}

export const TableCheckBox = ({ onChange, checked = false, color = 'blue', disabled = false }: Props) => {
  return <Checkbox color={color} size={'xs'} onChange={onChange} checked={checked} disabled={disabled} />;
};
